import { render, staticRenderFns } from "./IndexGeneralE.vue?vue&type=template&id=6ff84027&"
import script from "./IndexGeneralE.vue?vue&type=script&lang=js&"
export * from "./IndexGeneralE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports